import * as React from 'react';
import { Body } from 'vet-bones/design-system/components';

import {
  getProjectFileUploadPanelColumnDistinctTestId,
  getProjectFileUploadPanelColumnRecordsTestId,
} from 'src/constants/testIds';
import { ProjectFileUploadField } from 'src/store/state/projects';
import * as copy from 'src/templates/copy';
import { FullFileStats } from 'src/utils/csv/parseCsv';

import tableStyles from 'src/components/resourceDialog/styles/resourcePreviewTable.module.scss';

type FileUploadColumnStatsProps = {
  field: ProjectFileUploadField;
  fields: ProjectFileUploadField[];
  fullFileStats: FullFileStats | undefined;
};

export const FileUploadColumnStats: React.VFC<FileUploadColumnStatsProps> = ({
  field,
  fields,
  fullFileStats,
}) => {
  const idx = fields.indexOf(field);
  if (
    !fullFileStats ||
    idx < 0 ||
    fullFileStats.records.length !== fields.length ||
    fullFileStats.distinct.length !== fields.length
  ) {
    return null;
  }
  return (
    <div className={tableStyles.statistics}>
      <Body
        ellipsize
        size="sm"
        testId={getProjectFileUploadPanelColumnDistinctTestId(field.value)}
      >
        {copy.components.projectResourceDialog.projectFileUploadPanel.statistics.distinct(
          fullFileStats.distinct[idx]
        )}
      </Body>
      <Body
        ellipsize
        size="sm"
        testId={getProjectFileUploadPanelColumnRecordsTestId(field.value)}
      >
        {copy.components.projectResourceDialog.projectFileUploadPanel.statistics.records(
          fullFileStats.records[idx]
        )}
      </Body>
    </div>
  );
};
